import { FC, SetStateAction, Dispatch } from 'react';
import { DateRangePicker, FiltersButtons, FiltersLayout } from '../../../components';
import { Grid } from '@mui/material';
import { SalesNeighborhoodDropdown } from '../../../components/dropdowns/sales-neighborhood-dropdown';
import { SalesTerritoryDropdown } from '../../../components/dropdowns/sales-territory-dropdown';
import { IDateRange } from '../../../models';
interface ISellersAgentFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  setHasAppliedFilters: Dispatch<SetStateAction<boolean>>;
  hasAppliedFilters: boolean;
  setSelectedDateRange?: Dispatch<SetStateAction<IDateRange>>;
  selectedDateRange?: IDateRange | null;
  setSelectedTerritoryId?: (val: string | number) => void;
  selectedTerritoryId?: string | number;
  setSelectedNeighborhoodId?: (val: string | number) => void;
  selectedNeighborhoodId?: string | number;
}
export const SellersAgentFilters: FC<ISellersAgentFilters> = ({
  isLoading,
  applyFilters,
  setHasAppliedFilters,
  hasAppliedFilters,
  setSelectedDateRange,
  selectedDateRange,
  setSelectedTerritoryId,
  selectedTerritoryId,
  setSelectedNeighborhoodId,
  selectedNeighborhoodId
}) => {
  return (
    <FiltersLayout>
      {setSelectedDateRange && (
        <Grid item xs={12} sm={9} md={6} xl={3}>
          <DateRangePicker
            id="builds-contract-date-range"
            label="Builds Contract Started Date Range"
            value={selectedDateRange}
            onChange={value => {
            setSelectedDateRange(value);
            if (value.startDate && value.endDate) {
              setHasAppliedFilters(true);
            }
            else{
              setHasAppliedFilters(false);
            }
            }}
          fullWidth
          inputSize="small"
          />
        </Grid>)}
      {setSelectedTerritoryId && (
        <Grid item xs={12} sm={6} md={4} xl={2}>
          <SalesTerritoryDropdown
            value={selectedTerritoryId}
            handleChange={value => {
              setSelectedTerritoryId(value as string);
              //Reset all related selected values when a new value is set
              setSelectedNeighborhoodId('');
            }}
            apiParams={{ IsActive: true }}
            handleClear={() => {
              setSelectedTerritoryId('');
              setSelectedNeighborhoodId('');
            }}
            isDisabled={!selectedDateRange?.startDate || !selectedDateRange?.endDate}
          />
        </Grid>
      )}
      {setSelectedNeighborhoodId && (
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <SalesNeighborhoodDropdown
            value={selectedNeighborhoodId}
            handleChange={value => {
              setSelectedNeighborhoodId(value as string);
            }}
            apiParams={{ isActive: true, territoryId: selectedTerritoryId }}
            handleClear={() => {
              setSelectedNeighborhoodId('');
            }}
            isDisabled={!selectedDateRange?.startDate || !selectedDateRange?.endDate}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={5} xl={4}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading || !selectedDateRange?.startDate || !selectedDateRange?.endDate}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSelectedTerritoryId && setSelectedTerritoryId('');
            setSelectedNeighborhoodId && setSelectedNeighborhoodId('');
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};
